import React from "react"
import { useState } from "react"

import { Box } from "@mui/material"
import { IconButton } from "@mui/material"

import { MobileNavDrawer } from "./MobileNavDrawer"

const MobileNavIcon = ({ shopLink }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };
  return (
    <>
      <Box className="flex-row">
        <IconButton
          id="nav-icon"
          data-test-id="nav-icon"
          aria-label="toggle mobile navigation"
          onClick={toggleDrawer}
          sx={{
            height: "40px",
            width: "40px",
            border: "1px solid rgba(145, 158, 171, 0.1)",
            boxShadow: "0px 1px 3px rgba(145, 158, 171, 0.1)",
            borderRadius: "8px"
          }}
        >
          <img src="icons/menu-icon.svg" alt="menu-icon" />
        </IconButton>
      </Box>
      <MobileNavDrawer drawerOpen={drawerOpen} toggleDrawer={toggleDrawer} shopLink={shopLink} />
    </>
  )
}

export { MobileNavIcon }